import { SitesBuilderLibComponent, Indoor } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-indoor',
  templateUrl: './indoor.component.html',
  styleUrls: ['./indoor.component.scss'],
})
export class IndoorComponent implements OnInit {
  private subscriptions: Array<Subscription>;
  public tool: Indoor;
  @Output() exportTool = new EventEmitter<Indoor>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.indoor) {
        this.tool = JSON.parse(JSON.stringify(res.indoor));
      } else {
        console.error('Indoor tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  onSelect($event): void {
    this.exportTool.emit(this.tool);
  }
}
